// extracted by mini-css-extract-plugin
export var deleteModal = "_qe-0";